// Shared icon palette for courses — used by both the "New course" modal
// (views/home.js) and the "Edit course" modal (views/home.js, views/course.js)
// so every place a user picks a course icon offers the same choices.
// Grouped by subject area purely for readability here; the picker itself
// renders them as one flat, scrollable grid (see .emoji-picker in style.css).
export const COURSE_EMOJIS = [
  // General / original set
  '📘', '🔬', '📐', '🧮', '🌍', '⚛️', '🎨', '💡', '🧬', '🚀',
  '📚', '💻', '🎵', '🏛️', '⚖️', '💰', '🌐', '🧠', '🔭', '🗺️',
  '⚗️', '🌱', '🏗️', '🎭', '📊', '🍳', '⚽', '✈️', '🎬', '📷',
  // Math & logic
  '🔢', '➗', '📈', '📉', '♾️', '🧩',
  // Physics & energy
  '⚡', '🔋', '🧲', '🌡️', '☢️', '🔥',
  // Chemistry & materials
  '🧪', '💧',
  // Space & astronomy
  '🌌', '🪐', '☄️', '🛰️',
  // Biology & medicine
  '🧫', '🩺', '🦴', '🦠', '🌿', '🐛',
  // Earth & environment
  '🌋', '⛰️', '🌊', '⛅', '🧭',
  // Engineering & technology
  '⚙️', '🔧', '🖥️', '📡', '🔌', '🤖',
  // Language & literature
  '🗣️', '✍️', '📖', '📜',
  // History & civics
  '🏺', '🗳️',
  // Business & economics
  '💼', '🏦', '🛒',
  // Arts & performance
  '🎻', '🎹', '🖌️', '🎤',
  // Sports & fitness
  '🏏', '🏀', '🏸', '🏊', '🏃',
  // Food & agriculture
  '🌾', '🐄',
  // General / misc
  '🏆', '🎯', '🔑', '🧵', '✨',
];
